<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p>I would like to dedicate this book to one strong and beautiful individual, my mother, Dikitu Eshetu, who has sacrificed all her needs to make her children’s dreams come true. I love you.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?374d9a42